export default "__VITE_ASSET__BZpf8KUU__"